import styled from 'styled-components'

import { Theme } from '@web-apps/ui-shared'

export const StyledSlugInput = styled.div`
  position: relative;

  input {
    padding-left: var(--prefix-offset, 48px) !important;
  }
`

export const StyledPrefixDecorator = styled.div`
  display: flex;
  align-items: center;
`

export const StyledPrefixLabel = styled.span`
  font-weight: 600;
  white-space: nowrap;
  color: ${Theme.Colors.typography.inactive};
`
